var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-cases area"
  }, [_c("section", {
    staticClass: "product-cases__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CASES")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("他们都选择了同花顺Mac版")])]), _c("section", {
    staticClass: "product-cases__panel"
  }, [_c("div", {
    staticClass: "logos"
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };